export enum AttachmentEncodingType {
  Base64 = 0,
  RawBinary = 1,
}
